import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as proposal from '../proposal'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: proposal.RESOURCE.payload.dimension.partialId,
      partialId: proposal.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'The corresponding salesforce ID for this proposal',
    isOptional: true,
    name: 'Salesforce ID',
    partialId: PartialId.Standard.create('salesforce_id'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
